/// <amd-module name="Repos/Views/ProjectPolicies/Components/DeleteProjectPoliciesDialog" />
import * as React from "react";
import * as Resources from "Repos/Views/ProjectPolicies/Resources";
import { format } from "VSS/Core/Util/String";
import { MessageDialog } from "VSS/Features/PlatformUI/MessageDialog";
import { Observer } from "VSSUI/Observer";
import { IProjectPoliciesService, IProjectPolicyItem } from "../Contracts";
import { findPolicyTypeName } from "../PolicyTypeNames";
import { transformScopeForDisplay } from "../ReadableScope";

export interface IDeleteProjectPoliciesDialogProps {
    scope: string;
    projectPoliciesService: IProjectPoliciesService;
    onClose: (result: boolean) => void;
}

export class DeleteProjectPoliciesDialog extends React.Component<IDeleteProjectPoliciesDialogProps> {
    public render(): JSX.Element {
        const { scope, projectPoliciesService } = this.props;

        const { projectPolicies, projectPoliciesLoading, repositoryCount } = projectPoliciesService;

        const isDefault = scope === "*:~default";

        return (
            <Observer {...{ projectPolicies, projectPoliciesLoading, repositoryCount }}>
                {() => {
                    let policyItem = projectPoliciesService.projectPolicies.value.find(p => p.scope === scope);

                    if (policyItem == null) {
                        policyItem = {
                            scope: scope,
                            policyTypeIds: [""]
                        };
                    }

                    const policyTypeNames = policyItem.policyTypeIds.map(findPolicyTypeName).map((typeName, i) => <li key={i}>• {typeName}</li>);

                    let title: string, subTitle: string;

                    if (isDefault) {
                        title = Resources.DeleteDialogTitle_DefaultBranch;
                        subTitle = format(Resources.DeleteDialogSubTitle_DefaultBranch, repositoryCount.value);
                    } else {
                        title = format(Resources.DeleteDialogTitle_BranchPattern, transformScopeForDisplay(scope));
                        subTitle = format(Resources.DeleteDialogSubTitle_BranchPattern, repositoryCount.value);
                    }

                    const message = (
                        <div>
                            <div>{subTitle}</div>

                            <ul style={{ listStyleType: "disc" }}>{policyTypeNames}</ul>
                        </div>
                    );

                    return (
                        <MessageDialog
                            title={title}
                            message={message}
                            lightDismiss={true}
                            cancelButtonProps={{
                                text: Resources.Cancel,
                                disabled: projectPoliciesLoading.value
                            }}
                            okButtonProps={{
                                text: Resources.Remove,
                                disabled: projectPoliciesLoading.value,
                                primary: false,
                                className: "danger"
                            }}
                            onClose={this.onClose}
                        />
                    );
                }}
            </Observer>
        );
    }

    private onClose = (result: boolean): void => {
        const { scope, projectPoliciesService, onClose } = this.props;

        if (!result) {
            onClose(false);
        } else {
            projectPoliciesService.deleteAllPoliciesForScopeAsync(scope).then(() => onClose(true), () => onClose(false));
        }
    };
}
